module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jessica Trounstine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jessica Trounstine")]), _vm._v(" is assistant professor of politics and public affairs at Princeton University."), _c('br'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Kkk5fC/tc-custom/9780226812830.jpg?1734282769874",
      "alt": "This image is the cover for the book Political Monopolies in American Cities"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Political Monopolies in American Cities\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Around the same time that Richard J. Daley governed Chicago, greasing the wheels of his notorious political machine during a tenure that lasted from 1955 to his death in 1976, Anthony “Dutch” Hamann’s “reform” government centralized authority to similar effect in San Jose. In light of their equally exclusive governing arrangements—a similarity that seems to defy their reputations—Jessica Trounstine asks whether so-called bosses and reformers are more alike than we might have realized."), _c('br'), _c('br'), _vm._v(" Situating her in-depth studies of Chicago and San Jose in the broad context of data drawn from more than 240 cities over the course of a century, she finds that the answer—a resounding yes—illuminates the nature of political power. Both political machines and reform governments, she reveals, bias the system in favor of incumbents, effectively establishing monopolies that free governing coalitions from dependence on the support of their broader communities. Ironically, Trounstine goes on to show, the resulting loss of democratic responsiveness eventually mobilizes residents to vote monopolistic regimes out of office. Envisioning an alternative future for American cities, Trounstine concludes by suggesting solutions designed to free urban politics from this damaging cycle.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0